import React, { Component } from 'react';
import './LayoutGrid.css';
import BlogCell from './BlogCell';
import InfoCell from './InfoCell';
import { getShadowItem } from '../utils';

class LayoutGrid extends Component {
  render() {

    const {
      items,
      hasBlogCell,
    } = this.props;
    const shadowItem = getShadowItem(items);
    const rows = [];
  
    for (let i = 0; i < items.length; i = i + 2) {
      let firstCell = null;
      let secondCell = null;
  
      if (items[i]) {
        if (hasBlogCell) {
          firstCell = (
            <div className="lp-cell-wrapper">
              <BlogCell item={items[i]} shadowItem={shadowItem} />
            </div>
          );
        } else {
          firstCell = (
            <div className="lp-cell-wrapper">
              <InfoCell item={items[i]} shadowItem={shadowItem} />
            </div>
          );
        }
      }
      if (items[i + 1]) {
        if (hasBlogCell) {
          secondCell = (
            <div className="lp-cell-wrapper">
              <BlogCell item={items[i + 1]} shadowItem={shadowItem} />
            </div>
          );
        } else {
          secondCell = (
            <div className="lp-cell-wrapper">
              <InfoCell item={items[i + 1]} shadowItem={shadowItem} />
            </div>
          );
        }
      }
      rows.push(
        <div className="lp-grid-row" key={i}>
          {firstCell}
          {secondCell}
        </div>
      );
    }
    return (
      <div className="lp-layout-grid">
        {rows}
      </div>
    );
  }
}

export default LayoutGrid;



// WEBPACK FOOTER //
// ./src/components/LayoutGrid.js